export default "__VITE_ASSET__C1na9p86__"